import { useFormikContext } from 'formik';
import { FC } from 'react';
import { QcsCheckbox } from '../basic/QcsCheckbox';
import _ from 'lodash';
import { QcsFormControlLabel } from '../basic/QcsFormControlLabel';
import { SaveError } from '../SaveError';

interface Props {
  className?: string;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}

export const Checkbox: FC<Props> = ({
  className,
  name,
  label,
  disabled,
  onChange,
}) => {
  const { values, errors, handleChange } = useFormikContext<any>();
  const value = _.get(values, name);
  const errorText = _.get(errors, name) as string;

  return (
    <>
      <SaveError error={errorText} />
      <QcsFormControlLabel
        control={
          <QcsCheckbox
            className={className}
            id={name}
            name={name}
            checked={value}
            onChange={(e) => {
              handleChange(e);
              if (onChange) {
                onChange(e.target.checked);
              }
            }}
            disabled={disabled}
          />
        }
        label={label}
      />
    </>
  );
};
